import React from "react";
import { Button } from "@/components/ui/button";

interface ColumnSummaryProps {
  visibleCount: number;
  totalCount: number;
  onDone: () => void;
}

export function ColumnSummary({ visibleCount, totalCount, onDone }: ColumnSummaryProps) {
  return (
    <div className="flex items-center justify-between p-3 bg-card-50 rounded-lg">
      <span className="text-sm text-gray-600 dark:text-gray-400">
        {visibleCount} of {totalCount} columns visible
      </span>
      <Button onClick={onDone} size="sm">
        Done
      </Button>
    </div>
  );
}
